import React, { useEffect, useState } from "react";
import { Layers3 } from "lucide-react";
import { Tile } from "../Primitives";
import PolicyRulesPanel from "./PolicyRulesPanel";
import { OriginBadge } from "../../lib/origin.jsx";
import { getFeatures, getRules } from "../../lib/classificationApi";
import { ENGINES } from "../../lib/enginesApi";

const label = (id) => ENGINES.find(e => e.id === id)?.label || id;

// Engines Admin: the processed features every engine reads, with source and origin, plus the AI Policy Rules.
export default function FeatureSetPanel() {
  const [data, setData] = useState(null);
  const [rules, setRules] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    Promise.all([getFeatures(), getRules()]).then(([f, r]) => { setData(f); setRules(r); }).catch(e => setError(e.message));
  }, []);
  return (
    <>
      <Tile testid="feature-set-panel" dense
            title={<span className="text-[11px] font-semibold tracking-widest uppercase text-muted inline-flex items-center gap-2"><Layers3 size={12} className="text-primary" /> Feature Set · ABC × XYZ pipeline</span>}
            action={data && <span className="text-[10px] text-subtle font-mono-tabular">Run {data.run.run_id}</span>}>
        {error && <div className="p-4 text-[12px] text-critical" data-testid="feature-set-error">{error}</div>}
        {data && (
          <div className="overflow-x-auto">
            <table className="w-full text-[12px]">
              <thead><tr className="text-[10px] uppercase tracking-widest text-subtle border-b border-border">
                {["Feature", "Source", "Origin", "Used by"].map(h => <th key={h} className="text-left font-semibold px-4 py-2">{h}</th>)}
              </tr></thead>
              <tbody>
                {data.features.map((f, i) => (
                  <tr key={f.feature} data-testid={`feature-row-${i}`} className="border-b border-border/60 align-top hover:bg-surface-2/40">
                    <td className="px-4 py-2 font-medium whitespace-nowrap">{f.feature}</td>
                    <td className="px-4 py-2 text-muted text-[11.5px] min-w-[280px]">{f.source}</td>
                    <td className="px-4 py-2"><OriginBadge origin={f.origin} source={f.source} updatedAt={data.run.ran_at}
                                                          parts={f.origin === "mixed" ? data.origin.parts : undefined} testid={`feature-origin-${i}`} /></td>
                    <td className="px-4 py-2 text-[11px]">
                      {f.used_by.length === 7 ? <span className="text-fg/85">All seven engines</span> : f.used_by.map(label).join(", ")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Tile>
      <PolicyRulesPanel rules={rules?.rules} run={rules?.run} testid="engines-policy-rules" />
    </>
  );
}
